<template>
  <div>
    <PageTitle
      title="Purchases"
      :btnCreate="true"
      :createRoute="'/purchase/add'"
      :permission="'Purchase Create'"
    />
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-row>
        <v-col cols="12" lg="3" xl="4" md="12" sm="12" xs="12" class="py-2">
          <v-card style="background-color: #005985">
            <v-row style="color: white">
              <v-col cols="6"><div class="ml-3">Total Amount</div> </v-col>
              <v-col cols="6" class="text-right">
                <div class="mr-3">
                  {{ total | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" xl="4" md="12" sm="12" xs="12" class="py-2">
          <v-card style="background-color: #005985">
            <v-row style="color: white">
              <v-col cols="6"><div class="ml-3">Discount Amount</div> </v-col>
              <v-col cols="6" class="text-right">
                <div class="mr-3">
                  {{ discount | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" xl="4" md="12" sm="12" xs="12" class="py-2">
          <v-card style="background-color: #005985">
            <v-row style="color: white">
              <v-col cols="6"><div class="ml-3">Paid Amount</div> </v-col>
              <v-col cols="6" class="text-right">
                <div class="mr-3">
                  {{ paid | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" xl="4" md="12" sm="12" xs="12" class="py-2">
          <v-card style="background-color: #005985">
            <v-row style="color: white">
              <v-col cols="6">
                <div class="ml-3">Due Amount</div>
              </v-col>
              <v-col cols="6" class="text-right">
                <div class="mr-3">
                  {{ due | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="show">
          <TableFilters
            :filters="[
              'supplier',
              'search',
              'dateRange',
              'total',
              'warehouse',
              'purchaseStatus',
              'payment',
            ]"
            v-model="filter"
            :columns="columns"
            :msgs="'Reference No'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 list-table">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <form>
              <v-row v-if="messages.length != 0">
                <v-col>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <template>
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-card-text class="pa-0">
                  <v-data-table
                    :items-per-page="paginationOptions.perPage"
                    :headers="headers"
                    :items="PurchaseList"
                    @click:row="$router.push(`purchase/${$event.id}`)"
                    class="row-pointer"
                    hide-default-footer
                    style="font-family: 'Source Sans Pro', sans-serif"
                  >
                    <template v-slot:no-data>
                      <div class="mt-16 container justify-center item-center">
                        <noData name="Purchase" />
                      </div>
                    </template>
                    <template v-slot:item.reference_number="{ item }">
                      <div class="tbl-data">
                        <CopyTableCell
                          :text="item.reference_number"
                        ></CopyTableCell>
                      </div>
                    </template>
                    <!-- Status -->

                    <template v-slot:item.date="{ item }">
                      <div class="tbl-data">
                        {{ item.date ? item.date : '---------' | formatDate }}
                      </div>
                    </template>

                    <template v-slot:item.paid_amount="{ item }"
                      ><div class="px-4">
                        {{ item.paid_amount | formatCurrency }}
                      </div></template
                    >

                    <template v-slot:item.due="{ item }"
                      ><div class="px-4">
                        {{ item.due | formatCurrency }}
                      </div></template
                    >

                    <template v-slot:item.discount_amount="{ item }"
                      ><div class="px-4">
                        {{ item.discount_amount | formatCurrency }}
                      </div></template
                    >

                    <template v-slot:item.total_amount="{ item }"
                      ><div class="px-4">
                        {{ item.total_amount | formatCurrency }}
                      </div></template
                    >

                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :x-small="true"
                        label
                        text-color="white"
                        :color="GetChequeStatusColor(item.status)"
                        dark
                        class="tbl-data"
                        >{{ item.status }}</v-chip
                      ></template
                    >

                    <template v-slot:item.payment_status="{ item }">
                      <v-chip
                        :x-small="true"
                        label
                        text-color="white"
                        :color="
                          item.paid_amount &&
                          item.sub_total_amount <= item.paid_amount
                            ? 'green'
                            : '#FF4D4D'
                        "
                        dark
                      >
                        <div class="tbl-data">
                          {{
                            getPaymentStatus(
                              item.sub_total_amount,
                              item.paid_amount,
                            )
                          }}
                        </div>
                      </v-chip>

                      <v-tooltip top color="primary" v-if="item.purchaseOrder">
                        <template v-slot:activator="{ on, attrs }"
                          ><v-icon v-bind="attrs" v-on="on" x-small color="red"
                            >mdi-information</v-icon
                          ></template
                        >From Purchase Order</v-tooltip
                      >
                    </template>
                    <template v-slot:item.wareHouse.name="{ item }">
                      <div class="tbl-data">
                        {{
                          WarehouseView == 'name'
                            ? item.wareHouse.sortform
                            : item.wareHouse.name
                        }}
                      </div>
                    </template>
                    <template v-slot:item.supplier.name="{ item }">
                      <div class="tbl-data">
                        {{
                          SupplierView == 'name'
                            ? item.supplier.name
                            : item.supplier.name
                        }}
                      </div>
                    </template>
                    <!-- Actions -->
                    <template v-slot:item.actions="{ item }">
                      <list-menu
                        v-if="item.status == 'Pending'"
                        feature="purchase"
                        :item="item"
                        viewPermission="Purchase Show"
                        editPermission="Purchase Edit"
                        @refreshList="refreshData"
                      ></list-menu>
                      <list-menu
                        v-if="item.status != 'Pending'"
                        feature="purchase"
                        :item="item"
                        viewPermission="Purchase Show"
                        @refreshList="refreshData"
                      ></list-menu>
                    </template>
                    <template
                      slot="footer"
                      v-if="PurchaseList && PurchaseList.length > 0"
                      class="black--text"
                    >
                      <v-row>
                        <v-col sm="6" md="10" lg="10" class="title pl-6"
                          >Total</v-col
                        >
                        <v-col
                          class="title text-lg-center text-md-left text-right pr-0 pr-sm-15 pr-md-15 pr-lg-5"
                          >{{ grandTotal | formatCurrency }}</v-col
                        >
                      </v-row>
                    </template>
                    <template
                      slot="body.append"
                      v-if="PurchaseList && PurchaseList.length > 0"
                    >
                    </template>

                    <template v-slot:footer="{}">
                      <paginationComponent
                        @paginationOptions="setPaginationOptions"
                        :url="'purchases'"
                        :filterAction="true"
                        @getPageNumber="setPagenumber"
                        @response="receivePurchaseData"
                        :filter="filter"
                        ref="pagination"
                      />
                      <!-- :url="'purchases-orders'" -->
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-row>
            </form>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { PurchaseOrder } from '../../../models/EntityModels/PurchaseOrder';
import { required, email, max, numeric } from 'vee-validate/dist/rules';
import noData from '../../../components/shared/noItem';
import TableFilters from '@/components/base/TableFilters';

// Mixins
import Suppliers from '@/mixins/Suppliers';
import _ from 'lodash';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { Product } from '../../../models/Product';

import { ProductViewModel } from '../../../models/View Models/ProductViewModel';
import paginationComponent from '../../shared/components/pagination.vue';
import { mapGetters } from 'vuex';
import { has } from 'lodash';
import { mapState } from 'vuex';

import confirmation from '../../shared/components/confirmation';

extend('numeric', {
  ...numeric,
  message: 'input must be numeric',
});
export default {
  data: () => ({
    show: false,
    paginationOptions: {},
    grandTotal: '',
    messages: [],
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],

    columns: [
      {
        text: 'Date',
        value: 'date',
        show: true,
        align: 'left',
        disabled: false,
        width: '10%',
      },
      {
        text: 'Reference No',
        value: 'reference_number',
        show: true,
        align: 'left',
        disabled: false,
        width: '10%',
      },

      {
        text: 'Supplier',
        value: 'supplier.name',
        align: 'left',
        show: true,
        disabled: false,
        width: '10%',
      },
      {
        text: 'Warehouse',
        value: 'wareHouse.name',
        show: true,
        disabled: true,
        width: '10%',
        align: 'left',
        sortable: false,
      },

      {
        text: 'Purchase Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
        width: '10%',
      },

      {
        text: 'Total',
        value: 'total_amount',
        show: true,
        disabled: true,
        width: '10%',
        align: 'right',
      },
      {
        text: 'Discount',
        value: 'discount_amount',
        show: true,
        disabled: true,
        width: '10%',
        align: 'right',
      },
      {
        text: 'Paid',
        value: 'paid_amount',
        show: true,
        disabled: true,
        width: '10%',
        align: 'right',
      },
      {
        text: 'Due',
        value: 'due',
        show: true,
        disabled: true,
        width: '10%',
        align: 'right',
      },
      {
        text: 'Payment Status',
        value: 'payment_status',
        show: true,
        disabled: false,
        align: 'center',
        width: '10%',
        sortable: false,
      },

      {
        text: 'Actions',
        value: 'actions',
        show: true,
        disabled: true,
        align: 'center',
        width: '10%',
      },
    ],
    PurchaseList: [],
    filter: {
      invoice_status: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
      paymentStatus: '',
    },
    menu: false,
    total: 0,
    discount: 0,
    paid: 0,
    due: 0,
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    noData,
    TableFilters,
  },
  computed: {
    ...mapGetters(['getInvoiceStatusOptions']),
    ...mapState(['WarehouseView']),

    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    getPaymentStatus(total, paid) {
      return total <= paid ? 'Paid' : 'Due';
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    receivePurchaseData(data) {
      this.PurchaseList = data;
      this.PurchaseList.forEach((element) => {
        element['due'] = element.sub_total_amount - element.paid_amount;
      });
      this.due = this.sumField(this.PurchaseList, 'due');
      this.total = this.sumField(this.PurchaseList, 'total_amount');
      this.paid = this.sumField(this.PurchaseList, 'paid_amount');
      this.discount = this.sumField(this.PurchaseList, 'discount_amount');
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += element[filed];
      });
      return value;
    },
    GetChequeStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },

    viewPurchaseOrder(purchaseOrder) {
      this.$router.push(`/purchases/${purchaseOrder.id}`);
    },
    editPurchaseOrder(purchaseOrder) {
      this.$router.push(`/purchases/edit/${purchaseOrder.id}`);
    },
  },

  filters: {
    hasName: function (value) {
      if (has(value, 'name')) return value.name;
      else return '-';
    },
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  /* padding: 0 !important; */
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  /* padding: 0 !important; */
}
.v-application--is-ltr
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > th {
  /* padding: 0 !important; */
}
.tbl-data {
  /* font-weight: bold; */
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
